import { apiGet } from '../api.ts'
import { useQuery } from '@tanstack/react-query'
import { QueryCacheKeys } from '@/api/queryKeys.ts'
import { DISABLE_ALERTS_LIVE_FETCHING } from '@/constant/constant.ts'
import { useAlertStreamPolling } from '@/api/notification/stream/alertStreamStore.ts'

export const apiGetEmergencyLiveAlert = async () => {
    return await apiGet<IResGetEmergencyLive>(`/alert/emergency/live`)
}

const useQueryGetUrgentNotification = (enabled = false) => {
    const polling = useAlertStreamPolling('alert')

    return useQuery({
        enabled: enabled && !DISABLE_ALERTS_LIVE_FETCHING,
        queryKey: QueryCacheKeys.notification.getEmergencyAlertLive(),
        // 스트림이 연결돼 있는 동안은 서버가 변경을 밀어 준다. 끊겨 있을 때만 기존 폴링으로 복귀한다.
        refetchInterval: polling ? 1000 : false,
        queryFn: async () => {
            const { data } = await apiGetEmergencyLiveAlert()
            return data
        }
    })
}

export default useQueryGetUrgentNotification

export interface IResGetEmergencyLive {
    emergencies: IAlertEmergencyLiveItem[];
}

export interface IEmergenciesProtectee {
    id: number;
    name: string;
}

export interface IEmergenciesAlert {
    createdAt: string;
    taskManagerAt: string;
    isMyTask: boolean;
    type?: EmergencyAlertType;
    confirm?: string;
}

export enum EmergencyAlertType {
    SOS = 'sos',
    FALL = 'fall'
}

export interface IAlertEmergencyLiveItem {
    id: number;
    protectee: IEmergenciesProtectee;
    alert: IEmergenciesAlert;
}
